module.exports = __webpack_public_path__ + "img/ntpp5.fca62b34.png";